/* custom JS by Anatta Dev starts */

// to add GA4 click event on shop pay buttons

const waitForElementToExist = (selector) => {
  return new Promise(resolve => {
      if (document.querySelector(selector)) {
          return resolve(document.querySelector(selector));
      }

      const observer = new MutationObserver(() => {
          if (document.querySelector(selector)) {
              resolve(document.querySelector(selector));
              observer.disconnect();
          }
      });

      observer.observe(document.body, {
          subtree: true,
          childList: true,
      });
  });
}

waitForElementToExist('.quick-buy-drawer__info [data-testid="ShopifyPay-button"]').then(element => {
  $(element).attr({"data-gox-category": "quick-add", "data-gox-label": "quick-add-shoppay"});
});

waitForElementToExist('.additional-checkout-buttons-cartDrawer [data-testid="ShopifyPay-button"]').then(element => {
  $(element).attr({"data-gox-category": "cart-drawer", "data-gox-label": "shoppay-click"});
});

// For predictive search bar
const recommendedContainer = document.querySelector('.search__recommendedProducts');
const searchInputField = document.querySelector("[name='q']");
const headerSearchInput = document.querySelector('.js-header-searchBar');
const headerSearchIcon = $('.js-mobile-search-toggle');
const FocusEvent = new Event('focus');
const InputEvent = new Event('input');

searchInputField.addEventListener('focus', function(e) {
  if (!searchInputField.value.length) {
      recommendedContainer.classList.add('is--active');
      document.body.classList.add('lock', 'searchOverlay-active');
      document.querySelector('#js-search-usage-event').click();
  }
  if(window.innerWidth < 800 ){
    setTimeout(function() {
      window.scrollTo(0, 0);
    }, 300);
  }
});

document.addEventListener('click', (e) => {
  if (e.target.classList.contains('search-drawer')) {
      recommendedContainer.classList.remove('is--active');
      document.body.classList.remove('lock', 'searchOverlay-active');
      headerSearchInput.value = '';
      headerSearchInput.blur();
      searchInputField.value = '';
      searchInputField.dispatchEvent(InputEvent);
  }
});

if (document.querySelector('.js-submit-search-cta') !== null) {
  document.querySelector('.js-submit-search-cta').addEventListener('click', (e) => {
    document.querySelector('.predictive-search .empty-state') !== null 
      ? window.location.href = document.querySelector('.search__listFooterBtn').href
      : (document.querySelector('[action="/search"]').submit(), document.querySelector('#js-search-results-event').click());
  });
}

headerSearchInput.addEventListener('focus', function(e) {
  searchInputField.dispatchEvent(FocusEvent);
});

$(window).on('resize scroll', function() {
  if(window.innerWidth < 800 ){
    $('#main section').eq(0).isInViewport() 
      ? (headerSearchIcon.addClass('hidden'), $('search-drawer').removeClass('scroll-hidden'), $('.shopify-section-group-header-group.shopify-section--value-props').removeClass('hidden'))
      : (headerSearchIcon.removeClass('hidden'), $('search-drawer').addClass('scroll-hidden'), $('.shopify-section-group-header-group.shopify-section--value-props').addClass('hidden'))
  }
});

headerSearchIcon.on('click', ()=>{
  $('search-drawer').toggleClass('scroll-hidden');
  $('.shopify-section-group-header-group.shopify-section--value-props').toggleClass('hidden');
});

let timer;
const waitTime = 600;

headerSearchInput.addEventListener('keyup', event => {
  clearTimeout(timer);

  if (event.target.value.length === 0) {
      headerSearchInput.blur();
  }

  timer = setTimeout(() => {
      doneTyping(event.target.value);
  }, waitTime);
});

function doneTyping(value) {
  searchInputField.value = value;
  searchInputField.dispatchEvent(InputEvent);
}

$.fn.isInViewport = function() {
  var elementTop = $(this).offset().top;
  var elementBottom = elementTop + $(this).outerHeight();

  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();

  return elementBottom > viewportTop && elementTop < viewportBottom;
};

/* Predictive search bar functionality ends */

/* PDP accordions below CTA start */
if(document.querySelector('.faq__accordionBox details') != null){
  document.querySelector('.faq__accordionBox details summary').click();
}

$(".js-spec-drawer").click(function(){
  const drawerType =  $(this).data('type');
  $('.drawer-content-item').addClass('hidden');
  $(`.js-${drawerType}`).removeClass('hidden');
  $('.js-techDrawer-heading').text($(this).find('span').text());
  toggleTechDrawer('open');
});

$(".js-techDrawer-close").click(function(){
  toggleTechDrawer('close');
});

document.addEventListener('click', (e) => {
  if(e.target.classList.contains('js-drawer-overlay-box')){
    toggleTechDrawer('close');
  }
});


function toggleTechDrawer(state){
  if(state === 'open'){
    $(".drawer_wrapper").addClass("active");
    $("body").addClass("info");
  }
  else{
    $(".drawer_wrapper").removeClass("active");
    $("body").removeClass("info");
  }
}
/* PDP accordions below CTA ends */

if(window.innerWidth > 1200 ){
  $(window).scroll(function (e) {
    let scroll = $(window).scrollTop();

    scroll > 700 ?  $('.shopify-section-group-header-group.shopify-section--value-props').addClass('hidden') :  $('.shopify-section-group-header-group.shopify-section--value-props').removeClass('hidden');
  });
}

/* Collection Tabs Carousal */
const carousalTabHeading = document.querySelectorAll('.js-collection-tab');

carousalTabHeading.forEach( tab => {
  tab.addEventListener('click', e => {
    let collectionId = tab.dataset.id;
    removeActiveClass('.js-collection-tab');
    tab.classList.add('is--active');

    removeActiveClass('.js-collection-tab-content');
    document.querySelector(`.js-collection-tab-content#tabContent_${collectionId}`).classList.add('is--active');
  });
});

function removeActiveClass(selector, className='is--active'){
  document.querySelectorAll(selector).forEach(element => {
    element.classList.remove(className);
  });
}
/* Collection Tabs Carousal ends */
